/* src/app/forms/produtos/carrefour/carrefour-category/carrefour-category.component.scss */
.content {
  position: relative;
  padding-top: 6px;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 80%;
  padding-bottom: 6px;
}
.content-tree {
  display: flex;
  flex-direction: column;
  height: 50vh;
  overflow: auto;
  padding: 15px;
}
.pointerMenu {
  cursor: pointer;
}
/*# sourceMappingURL=carrefour-category.component.css.map */
